export default __webpack_public_path__ + "static/media/br.e01c0bc8.svg";